import { useLayoutEffect } from "react";

const useAutoSizeInput = (
  getElement: () => HTMLElement | null | undefined,
  minWidth?: number
) => {
  const autoSize = (element: HTMLElement) => {
    try {
      const { borderLeftWidth, borderRightWidth } = getComputedStyle(element);
      element.style.setProperty("width", `0px`);
      const numberPxToNumber = (numberPx: string) =>
        parseInt(numberPx.slice(0, -2));
      const borderWidth =
        numberPxToNumber(borderLeftWidth) + numberPxToNumber(borderRightWidth);
      let width = element.scrollWidth + borderWidth + 6;
      if (minWidth && width < minWidth) width = minWidth;
      element.style.setProperty("width", `${width}px`);
    } catch {}
  };

  useLayoutEffect(() => {
    const element = getElement();
    if (element) autoSize(element);
  });
};

export default useAutoSizeInput;
